import _ from "lodash";
import React from "react";
import styled, { css } from "styled-components";

import PrintColorRadio from "./shared/printColorRadio";
import HotStampingRadio from "./HotStampingRadio";
import PaperMaterialSelect from "./shared/paperMaterialSelect";
import { StyledMainDivider } from "./finishingCheckbox";

function CoverSection(props) {
  const {
    control,
    setValue,
    errors,
    trigger,
    coverFields,
    getValues,
    reset,
    watch,
    setPaperModalVisible,
    setAddPaperGrammageFrom, // Ni dari add.js
  } = props;

  return (
    <StyledContainer error={_.get(errors, "cover")}>
      {/*<Button onClick={() => coverAppend()}>Add Print Color</Button>*/}
      <StyledMainDivider>Cover</StyledMainDivider>
      <PrintColorRadio
        name="cover"
        control={control}
        setValue={setValue}
        errors={errors}
        trigger={trigger}
        fields={coverFields}
        getValues={getValues}
        reset={reset}
        watch={watch}
      />
      <PaperMaterialSelect
        name="cover"
        control={control}
        setValue={setValue}
        errors={errors}
        trigger={trigger}
        watch={watch}
        setPaperModalVisible={setPaperModalVisible}
        setAddPaperGrammageFrom={setAddPaperGrammageFrom}
        getValues={getValues}
      />
      <HotStampingRadio
        control={control}
        setValue={setValue}
        errors={errors}
        trigger={trigger}
        watch={watch}
      />
    </StyledContainer>
  );
}

export const StyledContainer = styled.div`
  padding: ${(props) => props.theme.spacing[4]};
  margin-bottom: ${(props) => props.theme.spacing[4]};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
  box-shadow: 3px 4px 0px 0px ${(props) => props.theme.colors.grey[400]};

  ${(props) =>
    props.error &&
    css`
      border: 1px solid ${(props) => props.theme.colors.red[400]};
      box-shadow: 3px 4px 0px 0px ${(props) => props.theme.colors.red[400]};
    `};
`;

export default CoverSection;
